<script lang="ts" setup>
import "./MField.scss";
import type { MFieldProps } from "./MField.props";
import { mFieldDefaults } from "./MField.props";

const props = withDefaults(defineProps<MFieldProps>(), mFieldDefaults);
</script>
<template>
  <div class="m-field">
    <label class="m-field__label">{{ props.label }}</label>
    <div class="m-field__content">
      <slot />
    </div>
  </div>
</template>
